import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Companies = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="relative bg-primary pt-32 pb-24 overflow-hidden">
        <div className="relative w-full px-12 lg:px-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl"
          >
            <span className="inline-block text-xs font-semibold tracking-[0.2em] text-white/40 uppercase mb-4">
              Nossas Empresas
            </span>
            <h1 className="text-4xl lg:text-5xl font-medium text-white leading-tight mb-6">
              Empresas do<br />Grupo Prime
            </h1>
            <p className="text-white/60 text-lg max-w-xl">
              Especialização e integração operacional para atender todas as suas necessidades
            </p>
          </motion.div>
        </div>
      </section>

      {/* Vallet Prime */}
      <section className="py-24 lg:py-32">
        <div className="w-full px-12 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="order-2 lg:order-1"
            >
              <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/c3572f2fc7991bc482df5952ce7ff02c/e335f7daceb9cb6a5d646b724a4b9543.png"
                  alt="Vallet Prime"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="order-1 lg:order-2"
            >
              <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center mb-8">
                <i className="ri-car-line text-3xl text-primary"></i>
              </div>
              <h2 className="text-3xl lg:text-4xl font-medium text-primary mb-4">
                Vallet Prime
              </h2>
              <p className="text-accent text-sm font-semibold tracking-[0.15em] uppercase mb-8">
                Valet Parking & Motorista Executivo
              </p>
              
              <div className="space-y-6 mb-10">
                <p className="text-secondary text-lg leading-relaxed">
                  A Vallet Prime é a empresa do Grupo Prime especializada em serviços de valet parking e motorista executivo, oferecendo soluções premium para eventos corporativos, sociais e empresas.
                </p>
                <p className="text-secondary text-lg leading-relaxed">
                  Com equipe altamente treinada e processos padronizados, garantimos segurança, organização e eficiência na gestão de estacionamento e condução de veículos corporativos.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-10">
                {[
                  'Gestão de estacionamento',
                  'Motorista executivo',
                  'Equipe uniformizada',
                  'Processos padronizados',
                  'Seguro veicular',
                  'Atendimento premium',
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-xs text-primary"></i>
                    </div>
                    <span className="text-secondary text-sm">{item}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/contato"
                className="inline-flex items-center gap-3 bg-primary text-white font-medium text-sm px-8 py-4 rounded-full hover:bg-primary/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Solicitar Orçamento
                <i className="ri-arrow-right-line"></i>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* TR Prorok */}
      <section className="bg-light py-24 lg:py-32">
        <div className="w-full px-12 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center mb-8">
                <i className="ri-truck-line text-3xl text-primary"></i>
              </div>
              <h2 className="text-3xl lg:text-4xl font-medium text-primary mb-4">
                TR Prorok
              </h2>
              <p className="text-secondary/60 text-sm font-semibold tracking-[0.15em] uppercase mb-8">
                Logística & Movimentação de Mobiliário
              </p>
              
              <div className="space-y-6 mb-10">
                <p className="text-secondary text-lg leading-relaxed">
                  A TR Prorok é a empresa do Grupo Prime especializada em logística, transporte e movimentação de mobiliário, oferecendo soluções completas para eventos, empresas e construtoras.
                </p>
                <p className="text-secondary text-lg leading-relaxed">
                  Com expertise em movimentação de estruturas, móveis e equipamentos, garantimos transporte seguro, organização logística e execução precisa.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-10">
                {[
                  'Transporte de mobiliário',
                  'Logística para eventos',
                  'Fretes corporativos',
                  'Equipe técnica',
                  'Cuidado no manuseio',
                ].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-xs text-primary"></i>
                    </div>
                    <span className="text-secondary text-sm">{item}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/contato"
                className="inline-flex items-center gap-3 bg-primary text-white font-medium text-sm px-8 py-4 rounded-full hover:bg-primary/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Solicitar Orçamento
                <i className="ri-arrow-right-line"></i>
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="relative aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/c3572f2fc7991bc482df5952ce7ff02c/f300221917998ff74644ed4a1cf2a04b.png"
                  alt="TR Prorok"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* Botão Flutuante WhatsApp */}
      <a
        href="https://wa.me/5541997438126"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 bg-[#25D366] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-xl hover:bg-[#20BA5A] hover:scale-110 transition-all duration-300 z-50 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
};

export default Companies;
